import React from "react"
import { Link } from "react-router-dom"
import './ProjectSectionS2.css'
import SectionTitle from "../SectionTitle/SectionTitle"

// Import service images
import jointPainImg from '../../images/services/Joint Pain & Arthritis Solutions.jpg';
import sexualWellnessImg from '../../images/services/Sexual Wellness & Performance.jpg';
import chronicPainImg from '../../images/services/Chronic Pain Management.jpg';
import neurologicalImg from '../../images/services/Neurological Recovery & Support.jpg';
import athleticImg from '../../images/services/Athletic Performance & Sports Medicine.jpg';
import antiAgingImg from '../../images/services/Anti-Aging & Longevity.jpg';
import neurodegenerativeImg from '../../images/services/Neurodegenerative-and-Dementia-Therapy.jpg';
import developmentalImg from '../../images/services/Developmental Disorders - Autism Spectrum.jpg';
import museCellsImg from '../../images/services/muse cells.jpg';

const ClickHandler = () => {
    window.scrollTo(10, 0)
}

const ProjectSectionS2 = (props) => {
    
    const treatments = [
        {
            id: 1,
            image: jointPainImg,
            title: 'Joint Pain & Arthritis Solutions',
            description: 'Advanced cellular therapies for knee, hip, shoulder arthritis and degenerative joint conditions',
            slug: 'joint-pain-arthritis'
        },
        {
            id: 2,
            image: sexualWellnessImg,
            title: 'Sexual Wellness & Performance',
            description: "Men's and women's wellness and health solutions, performance enhancement and regenerative protocols",
            slug: 'sexual-wellness'
        },
        {
            id: 3,
            image: chronicPainImg,
            title: 'Chronic Pain Management',
            description: 'Root-cause treatments for back, neck and neuropathic pain using regenerative medicine protocols',
            slug: 'chronic-pain'
        },
        {
            id: 4,
            image: neurologicalImg,
            title: 'Neurological Recovery & Support',
            description: 'Advanced cellular therapies for post-stroke recovery, neuropathy and neurological rehabilitation',
            slug: 'neurological-recovery'
        },
        {
            id: 5,
            image: athleticImg,
            title: 'Athletic Performance & Sports Medicine',
            description: 'Accelerated injury recovery, performance optimization and preventive treatments for active individuals',
            slug: 'athletic-performance'
        },
        {
            id: 6,
            image: antiAgingImg,
            title: 'Anti-Aging & Longevity',
            description: 'Comprehensive cellular regeneration for vitality enhancement, metabolic optimization and healthy aging',
            slug: 'anti-aging'
        },
        {
            id: 7,
            image: neurodegenerativeImg,
            title: 'Neurodegenerative & Dementia Therapy',
            description: "Innovative cellular protocols for Alzheimer's, Parkinson's and cognitive decline support",
            slug: 'neurodegenerative-dementia'
        },
        {
            id: 8,
            image: developmentalImg,
            title: 'Developmental Disorders - Autism Spectrum',
            description: 'Specialized regenerative therapies supporting neurological development and behavioral improvements',
            slug: 'developmental-disorders'
        },
        {
            id: 9,
            image: museCellsImg,
            title: 'MUSE Cell Therapy',
            description: 'Ultra-advanced multilineage stem cells for complex conditions and comprehensive tissue regeneration',
            slug: 'muse-cells'
        }
    ];
    
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 col-12">
                        <SectionTitle title={"Florida's Advanced Regenerative Medicine Solutions"} subtitle={'World-class stem cell therapies available domestically through Florida\'s progressive legislation'} />
                    </div>
                </div>
                <div className="project_grid">
                    <div className="row">
                        {treatments.map((treatment, index) => (
                            <div key={index} className="col-lg-4 col-md-6 col-12">
                                <div className="project_card">
                                    <div className="project_img">
                                        <img src={treatment.image} alt={treatment.title} />
                                    </div>
                                    <div className="text">
                                        <h2>{treatment.title}</h2>
                                        <p className="treatment-description">{treatment.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
export default ProjectSectionS2